import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["item"]

  connect() {
    this.dragItem = null
  }

  // --- drag handle events (called via data-action on the handle) ---

  dragstart(event) {
    this.dragItem = event.target.closest("[data-sortable-target='item']")
    if (!this.dragItem) return

    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", "")
    requestAnimationFrame(() => this.dragItem.classList.add("is-dragging"))
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.target.closest("[data-sortable-target='item']")
    if (!target || target === this.dragItem) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.dragItem, target)
    } else {
      target.parentNode.insertBefore(this.dragItem, target.nextSibling)
    }
  }

  dragend() {
    if (this.dragItem) {
      this.dragItem.classList.remove("is-dragging")
      this.dragItem = null
    }

    this.updateNumbers()
    this.saveOrder()
  }

  // --- private ---

  updateNumbers() {
    this.itemTargets.forEach((item, index) => {
      const num = item.querySelector("[data-series-number]")
      if (num) num.textContent = `${index + 1}.`
    })
  }

  saveOrder() {
    const ids = this.itemTargets.map(item => item.dataset.id)
    const token = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        Accept: "application/json"
      },
      body: JSON.stringify({ positions: ids })
    })
  }
}
